<div class="request-funds-card" *ngIf="!isMobile">
    <div class="card card-inverse">
        <div class="card-header" i18n="Submit Request card header">Submit Request</div>
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
</div>

<div class="request-funds-card" *ngIf="isMobile">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</div>

<ng-template #requestTemplate>
    <div *ngIf="!isMobile">
        <ng-container *ngTemplateOutlet="requestDesktopTemplate"></ng-container>
    </div>
    <div *ngIf="isMobile">
        <ng-container *ngTemplateOutlet="requestMobileTemplate"></ng-container>
    </div>
</ng-template>

<ng-template #requestDesktopTemplate>
    <form [formGroup]="formGroup" (ngSubmit)="addReserveRelease()">
        <div class="card-body">
            <div class="inner-wrapper">
                <div class="row deadline-row">
                    <div class="col">
                        <p i18n="Submit Request card priority information">
                            Requests made prior to 3 p.m. ET will be given same day priority.
                        </p>
                    </div>
                </div>
                <div class="radio-options-section">
                    <div class="row available-funds-row" *ngIf="availability">
                        <div class="col">
                            <lsq-radio
                                i18n-label="
                                    Submit request funds radio button to select option to withdraw
                                    available amount
                                "
                                label="Available to Withdraw"
                                [name]="'isDefault'"
                                [id]="'defaultAmount'"
                                [value]="true"
                                [disabled]="disabledDefaultAmount"
                                formControlName="isDefault"
                            >
                            </lsq-radio>
                            <div class="flex-grow"></div>
                            <h4>
                                {{ (availableToWithdraw > 0 ? availableToWithdraw : 0) | currency }}
                                <lsq-icon
                                    [type]="icon.Info"
                                    [color]="color.Gray"
                                    [ngClass]="[
                                        classNames.TableCellPopoverIcon,
                                        classNames.PopoverIcon
                                    ]"
                                    [popover]="availabilityPopover"
                                    [popoverPlacement]="placement.BottomLeft"
                                >
                                </lsq-icon>
                            </h4>
                            <popover-content #availabilityPopover [size]="size.MediumSmall">
                                <table class="expense-popover">
                                    <tbody>
                                        <tr>
                                            <td i18n="Available to withdraw tooltip label">
                                                Available Funds
                                            </td>
                                            <td class="text-right">
                                                {{ availability | currency }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td i18n="Available to withdraw tooltip label">
                                                Pending Fund Requests
                                            </td>
                                            <td>
                                                <div>
                                                    <lsq-icon
                                                        [type]="icon.MinusSign"
                                                        [color]="color.Black"
                                                    ></lsq-icon>
                                                    {{ totalPendingAmount | currency }}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td i18n="Available to withdraw tooltip label">
                                                Available to Withdraw
                                            </td>
                                            <td>
                                                {{ availableToWithdraw | currency }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </popover-content>
                        </div>
                    </div>
                    <div class="row request-funds-row" *ngIf="formGroup">
                        <div
                            class="request-funds-radio"
                            [ngClass]="!formGroup.get('isDefault').value ? 'col-5' : 'col-12'"
                        >
                            <div class="request-funds-radio-container">
                                <lsq-radio
                                    i18n-label="
                                        Submit request funds radio button to select option to enter
                                        a dollar amount
                                    "
                                    label="Other Amount"
                                    [name]="'isDefault'"
                                    [id]="'customAmount'"
                                    [value]="false"
                                    formControlName="isDefault"
                                >
                                </lsq-radio>
                            </div>
                        </div>
                        <div class="col-7" *ngIf="!formGroup.get('isDefault').value">
                            <lsq-currency-input
                                name="requestAmount"
                                class="request-funds-request-amount"
                                placeholder="0.00"
                                formControlName="requestAmount"
                                [autoFocus]="
                                    !formGroup.get('isDefault').value && !disabledDefaultAmount
                                "
                                [group]="formGroup"
                            >
                            </lsq-currency-input>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="bankAccountOptions?.length > 0">
                    <div class="col">
                        <lsq-select
                            i18n-label="Submit request funds select bank account dropdown label"
                            label="Bank Account"
                            border="light"
                            parentClass="request-funds-bank-account"
                            name="bankAccountKey"
                            formControlName="bankAccountKey"
                            [group]="formGroup"
                            [dropUp]="false"
                            [innerLabel]="true"
                            [isNullable]="false"
                            [arrow]="true"
                            [options]="bankAccountOptions"
                        >
                        </lsq-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <lsq-textarea
                            label="Notes"
                            i18n-label="Submit request funds notes field label"
                            name="notes"
                            class="request-funds-notes"
                            [resize]="false"
                            [rows]="3"
                            [floatLabel]="false"
                            [group]="formGroup"
                            placeholder="Notes"
                            formControlName="notes"
                        >
                        </lsq-textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-right">
            <lsq-button
                i18n="Submit request funds submit button"
                type="submit"
                [group]="formGroup"
                [disabled]="!formGroup.valid"
                [submitting]="submitting"
            >
                Submit
            </lsq-button>
        </div>
    </form>
</ng-template>

<ng-template #cancelRequestErrorModalTemplate>
    <div class="modal-body" i18n="Cancel request funds modal">
        In order to cancel this request, please contact your Account Manager because it is currently
        under review.
    </div>
</ng-template>

<ng-template #processingTemplate>
    <div [ngClass]="!isMobile ? 'card-body' : 'mobile-processing'">
        <div class="inner-wrapper-processing">
            <div class="row">
                <div class="col" class="text-center">
                    <h3>
                        <span
                            i18n="
                                Part 1/3: 'Your request to fund <BankAccountName> for <DollarAmount>
                                is being processed.'
                            "
                        >
                            Your request to fund
                        </span>
                        <br *ngIf="isMobile" />
                        <span>{{ getRequestedBankAccountName() }}</span>
                        <span
                            i18n="
                                Part 2/3: 'Your request to fund <BankAccountName> for <DollarAmount>
                                is being processed.'
                            "
                        >
                            for
                        </span>
                        <span>{{ requestedAmount | currency }}</span>
                        <span
                            i18n="
                                Part 3/3: 'Your request to fund <BankAccountName> for <DollarAmount>
                                is being processed.'
                            "
                        >
                            is being processed.
                        </span>
                    </h3>
                    <p>
                        <a
                            class="text-bold"
                            (click)="handleAdditionalRequestClick()"
                            i18n="Request Funds submit additional request button"
                        >
                            Submit An Additional Request
                        </a>
                    </p>
                    <hr />
                    <p class="cancel-request-section">
                        <a
                            class="text-bold secondary-anchor"
                            (click)="handleCancelRequestClick()"
                            i18n="Request Funds cancel request button"
                        >
                            Cancel Request
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-footer-button-container" *ngIf="isMobile">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <lsq-button
                        type="submit"
                        size="block"
                        (buttonClick)="returnToDashboard()"
                        i18n="Return to Dashboard homepage button"
                    >
                        Back to Dashboard
                    </lsq-button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #canceledTemplate>
    <div [ngClass]="!isMobile ? 'card-body' : 'mobile-cancelled'">
        <div class="inner-wrapper">
            <div class="row">
                <div class="col text-center">
                    <p><lsq-icon [type]="icon.XCircle"></lsq-icon></p>
                    <h3>
                        <span
                            i18n="
                                Part 1/3 of: Your request to fund {{ bankAccountName }} for {{
                                dollarAmount }} has been canceled.
                            "
                            >Your request to fund
                        </span>
                        <span>{{ getRequestedBankAccountName() }}</span>
                        <span
                            i18n="
                                Part 2/3 of: Your request to fund {{ bankAccountName }} for {{
                                dollarAmount }} has been canceled.
                            "
                        >
                            for
                        </span>
                        <span>{{ requestedAmount | currency }}</span>
                        <span
                            i18n="
                                Part 3/3 of: Your request to fund {{ bankAccountName }} for {{
                                dollarAmount }} has been canceled.
                            "
                        >
                            has been canceled.</span
                        >
                    </h3>
                    <p class="additional-request-section">
                        <a
                            class="text-bold"
                            (click)="handleAdditionalRequestClick()"
                            i18n="Request Funds submit additional request button"
                        >
                            Submit An Additional Request
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-footer-button-container" *ngIf="isMobile">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <lsq-button
                        type="submit"
                        size="block"
                        (buttonClick)="returnToDashboard()"
                        i18n="Return to Dashboard homepage button"
                    >
                        Back to Dashboard
                    </lsq-button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Request funds mobile templates. -->
<ng-template #requestMobileTemplate>
    <lsq-circle-loader *ngIf="initializing"></lsq-circle-loader>
    <form
        *ngIf="!initializing"
        class="mobile"
        [formGroup]="formGroup"
        (ngSubmit)="addReserveRelease()"
    >
        <div class="row mobile-tagline-row">
            <div class="col">
                <p class="mobile-tagline" i18n="Submit Request priority information">
                    Requests made prior to 3 p.m. ET will be given same day priority.
                </p>
            </div>
        </div>
        <div class="mobile-request-funds-form-fields">
            <div
                class="row mobile-availability-row available-funds-row"
                *ngIf="availableToWithdraw > 0"
            >
                <div class="col">
                    <ul class="list-inline list-unstyled mobile-availability">
                        <li>
                            <lsq-radio
                                label="Available to Withdraw"
                                i18n-label="
                                    Submit request funds radio button to select option to withdraw
                                    available amount
                                "
                                [name]="'isDefault'"
                                [id]="'defaultAmount'"
                                [value]="true"
                                [disabled]="disabledDefaultAmount"
                                formControlName="isDefault"
                            >
                            </lsq-radio>
                        </li>
                        <li>
                            {{ availableToWithdraw | currency }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row other-amount-row" *ngIf="formGroup">
                <div class="col">
                    <ul class="list-inline list-unstyled mobile-availability">
                        <li>
                            <lsq-radio
                                label="Other Amount"
                                i18n-label="
                                    Submit request funds radio button to select option to enter a
                                    dollar amount
                                "
                                [name]="'isDefault'"
                                [id]="'customAmount'"
                                [value]="false"
                                formControlName="isDefault"
                            >
                            </lsq-radio>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                *ngIf="formGroup && !formGroup.get('isDefault').value"
                [ngClass]="!formGroup.get('isDefault').value ? 'row request-amount' : 'row'"
            >
                <div class="col">
                    <lsq-currency-input
                        label="Other Amount"
                        i18n-label="Submit request funds currency input"
                        name="requestAmount"
                        class="request-funds-request-amount"
                        placeholder="0.00"
                        formControlName="requestAmount"
                        [autoFocus]="!formGroup.get('isDefault').value && !disabledDefaultAmount"
                        [group]="formGroup"
                    >
                    </lsq-currency-input>
                </div>
            </div>
            <div class="row" *ngIf="bankAccountOptions?.length > 0">
                <div class="col-12">
                    <lsq-select
                        label="Bank Account"
                        i18n-label="Submit request funds select bank account dropdown label"
                        border="light"
                        parentClass="request-funds-bank-account"
                        name="bankAccountKey"
                        formControlName="bankAccountKey"
                        [group]="formGroup"
                        [dropUp]="true"
                        [innerLabel]="true"
                        [isNullable]="false"
                        [arrow]="true"
                        [options]="bankAccountOptions"
                    >
                    </lsq-select>
                </div>

                <div class="col-12 note-col" *ngIf="!displayNoteInput">
                    <p class="text-center">
                        <a
                            class="mobile-link"
                            (click)="toggleNoteInput()"
                            i18n="Toggle button to show the input to write a note"
                            >Add A Note</a
                        >
                    </p>
                </div>

                <div class="col-12 note-col" *ngIf="displayNoteInput">
                    <lsq-textarea
                        label="Notes"
                        i18n-label="Submit request funds notes field label"
                        name="notes"
                        class="request-funds-notes"
                        [resize]="false"
                        [rows]="3"
                        [floatLabel]="false"
                        [group]="formGroup"
                        placeholder="Notes"
                        formControlName="notes"
                    >
                    </lsq-textarea>
                </div>
            </div>
        </div>

        <div class="mobile-footer-button-container">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <lsq-button
                            type="submit"
                            i18n="Submit request funds submit button"
                            size="block"
                            [group]="formGroup"
                            [disabled]="!formGroup.valid"
                            [submitting]="submitting"
                        >
                            Submit
                        </lsq-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>
